import { useEffect, useState } from 'react';

interface TimeWrapperProps {
  children: React.ReactNode;
  delay: number;
  destroy: boolean;
}

const TimeWrapper = ({ delay, destroy, children }: TimeWrapperProps) => {
  const [show, setShow] = useState(() => {
    return delay <= 0;
  });

  useEffect(() => {
    let showTimer: number | undefined = undefined;
    let destroyTimer: number | undefined = undefined;
    if (delay > 0) {
      showTimer = window.setTimeout(() => setShow(true), delay);
    }
    if (destroy) {
      destroyTimer = window.setTimeout(() => setShow(false), delay + 600);
    }
    return () => {
      if (delay > 0) {
        clearTimeout(showTimer);
      }
      if (destroy) {
        clearTimeout(destroyTimer);
      }
    };
  }, [delay, destroy]);

  return show ? <>{children}</> : null;
};

export default TimeWrapper;
